import { styled } from 'troyfe';

const Wrap = styled.div`
  width: 100%;
  height: 100%;
  display: flex;

  .left {
    width: 15%;
    height: 100%;
    background: #f8f8f8;
    .ant-menu-submenu-title {
      margin: 0;
      padding: 0;
      /* background-color: #44bb55; */
    }
    .ant-menu-item {
      /* padding-left: 72px !important; */
    }
    .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
      background-color: rgb(248, 248, 248);
    }
    .ant-menu-item::after {
      background: rgb(248, 248, 248);
    }
    .ant-menu-submenu-title:hover {
      background-color: rgb(248, 248, 248);
    }
    .ant-menu-inline .ant-menu-item::after {
      border-right: 3px solid rgb(248, 248, 248) !important;
    }
  }
  .right {
    flex: 1;
    padding: 0 2rem;
  }
  .title {
    font-size: 16px;
    font-weight: 540;
    padding: 10px;
    border-bottom: 1px solid #e2e2e2;
  }
  .add {
    color: #fff;
    margin: 10px 0;
    background-color: #44bb55;
  }
  .operation {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    li {
      color: #44bb55;
      margin: 0 16px 0 0;
    }

    li:last-child {
      margin: 0;
    }

    li:hover {
      cursor: pointer;
    }
  }
  .ant-pagination {
    margin-top: 8px;
    text-align: right;
  }
`;

const DrawerStyle = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;

  .drawer-top {
    padding: 1.31rem 0;
    border-bottom: 0.06rem solid #f1f2f4;
    h1 {
      text-align: center;
      color: #333333;
      font-size: 1.8rem;
      font-weight: 540;
    }
    .clear {
      float: right;
      font-size: 1rem;
      width: 1.38rem;
      cursor: pointer;
      font-weight: 500;
      margin-right: 2rem;
      transform: scale(1.8);
    }
  }
  .drawer-content {
    flex: 1;
    .form {
      width: 74%;
      margin: 2.5rem auto;
      input {
        height: 4.8rem;
        font-size: 1.6rem;
      }
      .ant-form-item-label {
        width: 24%;
      }
      .ant-form-item-label > label {
        height: 4.8rem;
        justify-content: end;
        font-size: 1.6rem;
        font-weight: 500;
      }
      .ant-picker {
        line-height: 4.8rem;
        height: 4.8rem;
      }
      .ant-input-affix-wrapper {
        padding: 0 0.69rem;
      }
      .ant-select-single .ant-select-selector .ant-select-selection-item {
        height: 4.8rem;
        line-height: 4.8rem;
        font-size: 1.6rem;
      }
      .ant-select-selector {
        height: 4.8rem;
        color: #1b1b1d;
        font-size: 1.6rem;
      }
      .ant-select-selection-placeholder {
        line-height: 4.8rem;
      }
      .labelName {
        .ant-form-item-required {
          display: none;
        }
      }
    }
    .list {
      margin: 3rem 6.2rem 0;
      li {
        display: flex;
        min-height: 4.8rem;
        label {
          text-align: right;
          width: 25%;
          color: #1b1b1d;
          font-size: 1.6rem;
          font-weight: 550;
        }
        div {
          flex: 1;
          font-size: 1.6rem;
        }
      }
    }
  }

  /* 提交按钮 */
  .handle {
    width: 100%;
    background: #fff;
    display: flex;
    justify-content: center;
    border-top: 0.06rem solid #f1f2f4;
    padding: 0.94rem 0;
  }
  .cancel,
  .confirm {
    width: 12rem;
    height: 4.8rem;
  }
  .cancel {
    background: #fff;
    border: 0.06rem solid #44bb55;
    color: #44bb55;
  }
  .confirm {
    margin-left: 2rem;
    background-color: #44bb55;
    border-color: #44bb55;
    color: #fff;
  }
`;

export { Wrap, DrawerStyle };
